<div id="main-wrapper">
    <header class="topbar p-3 text-center" data-navbarbg="skin6">
        <a class="navbar-brand" rel="home" title="Buy Sell Rent Everyting">
            <img style="max-width:310px; margin-top: -21px;"
                 src="/assets/images/flaggernylogo1.png">
        </a>
    </header>
    <div class="page-wrapper">
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
